//#region IMPORT
import { Button } from '../../../../Components/MUIs';
import { Box, Stack, Typography } from '@mui/material';
import PinchZoom from '../../../../Components/Ui/PinchZoom';
//#endregion

function M_TBG_CUSTOM_05(props) {
  return (
    <>
      <Stack sx={{ display: 'flex', alignItems: 'start', m: 2, mt: 0 }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          작업허가서
        </Typography>
        <Typography sx={{ color: '#828282' }}>
          PDF 자료를 통해 작업허가서를 확인해주세요.
        </Typography>
      </Stack>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          width: '100%',
          overflow: 'hidden', // 스크롤 방지
        }}
      >
        {props.loading ? (
          <Typography sx={{ color: '#4b4949ff', mt: 2 }}>
            작업허가서를 불러오는 중...
          </Typography>
        ) : props.pdfImages.length > 0 ? (
          <PinchZoom
            contents={props.pdfImages.map((src, idx) => (
              <img
                key={idx}
                src={src}
                alt={`PDF page ${idx + 1}`}
                style={{ width: '100%', marginBottom: '10px' }}
              />
            ))}
          />
        ) : (
          <Typography sx={{ color: '#4b4949ff', mt: 2 }}>
            작업허가서가 없습니다.
          </Typography>
        )}
        <Stack
          direction={'row'}
          justifyContent="space-between"
          alignItems="center"
          sx={{
            display: 'flex',
            gap: '5rem',
            p: 2,
            width: '100%',
          }}
        >
          <Button
            sx={{
              width: '100%',
              height: '36px',
              borderRadius: '18px',
            }}
            name="이전"
            onClick={props.goToPrevPage}
          />

          <Button
            sx={{
              width: '100%',
              height: '36px',
              borderRadius: '18px',
            }}
            name={
              props.pageNumber === props.numPages || !props.pdfFile
                ? '완료'
                : '다음'
            }
            onClick={() => {
              if (props.pageNumber === props.numPages || !props.pdfFile) {
                props.ActiveButton({
                  type: 'check2', // pdf교육 완료
                  id: props.userInfo.userid,
                  content: true,
                });
                props.setActiveStep(props.activeStep + 1);
              } else {
                props.goToNextPage();
              }
            }}
          />
        </Stack>
      </Box>
    </>
  );
}

export default M_TBG_CUSTOM_05;
